import { makeAutoObservable, runInAction } from 'mobx';
import { v4 } from 'uuid';

import { cmApi } from '@src/api';
import type { AppAuditDto, AppModuleDto, CmApi } from '@src/api';

import { preloaderStore } from '../preloaderStore';

class AuditStore {
  allModules: AppModuleDto[] = [];

  operationsByModuleAndService: AppModuleDto = {};

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  getAllModules = async (): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const { data } = await this.api.system.getAllModules();

      if (data) {
        runInAction(() => {
          this.allModules = data ?? [];
        });
      }
    } catch (err) {
      console.error(err);
    }
    preloaderStore.preloader(false);
  };

  getOperationsByModuleAndService = async (moduleName: string, serviceName: string): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const { data } = await this.api.system.getOperationsByModuleAndService({ moduleName, serviceName });

      if (data) {
        runInAction(() => {
          this.operationsByModuleAndService = data ?? {};
        });
      }
    } catch (err) {
      console.error(err);
    }
    preloaderStore.preloader(false);
  };

  createAuditData = (audit: AppAuditDto) => {
    preloaderStore.preloader(true);
    try {
      this.api.audit.createAuditData({ ...audit, id: v4() });
    } catch (err) {
      console.error(err);
    }
    preloaderStore.preloader(false);
  };
}

export const auditStore = new AuditStore({ api: cmApi });
